import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Other Texts',
  basePath: '/text-other',
  rowKey: 'pid',
  columns: [
    { key: 'country_name', label: 'Country', sortable: true },
    { key: 'var_name', label: 'Variable', sortable: true },
  ],
  fields: [
    { key: 'pid', label: 'ID', type: 'hidden' },
    { key: 'country', label: 'Country', type: 'async-select',
      optionsUrl: '/countries/options', required: true },
    { key: 'var', label: 'Variable', type: 'async-select',
      optionsUrl: '/text-other-vars/options', required: true },
    { key: 'term', label: 'Text', type: 'rich-text' },
  ],
  defaultSort: { field: 'country_name', dir: 'asc' },
});
